import { render } from "./AddValidationCheckPage.vue?vue&type=template&id=261ec924&ts=true"
import script from "./AddValidationCheckPage.vue?vue&type=script&lang=ts"
export * from "./AddValidationCheckPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__